import { useRoute, useRouter } from 'vue-router'

export function addQueryParamToURL(paramName: string, paramValue: string): void {
  const router = useRouter()
  const currentRoute = router.currentRoute.value

  router.push({
    path: currentRoute.path,
    query: {
      ...currentRoute.query,
      [paramName]: paramValue,
    },
  })
}